export type RouterShape = {
  page: Page | null;
};

export const routes = {
  previewCreative: 'preview/:assetID/creatives',
  previewSingle: 'preview/:assetID/single',
  preview: 'preview/:assetID',
  viewer: '/viewer/',
  pack: '/pack/',
  favorite: '/favorite/',
  sharing: '/sharing/:sharingId/',
  sharingLinks: '/sharing-links/',
};

export enum Page {
  viewer = 'viewer',
  pack = 'pack',
  favorite = 'favorite',
  sharing = 'sharing',
  sharingLinks = 'sharingLinks',
}

export const navigateToRoute = (route: string) => {
  // Используем, когда нет доступа к хукам. Например, в лисенерах.
  window.location.hash = route;
};
